"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useCurrency = void 0;
var react_1 = require("react");
var currency_1 = require("../utils/currency");
/**
 * Custom hook to get currency configuration from site config
 * @param siteConfig - Site configuration object
 * @returns Currency configuration with formatting utilities
 */
var useCurrency = function (siteConfig) {
    var currency = (0, react_1.useMemo)(function () {
        var _a;
        // If site config has currency, use it
        if (siteConfig === null || siteConfig === void 0 ? void 0 : siteConfig.currency) {
            return siteConfig.currency;
        }
        // If site config has currency code only, get full config
        if ((_a = siteConfig === null || siteConfig === void 0 ? void 0 : siteConfig.currency) === null || _a === void 0 ? void 0 : _a.code) {
            return (0, currency_1.getCurrencyByCode)(siteConfig.currency.code);
        }
        // Default to NAD (Namibian Dollar) for LEWFIN
        return currency_1.DEFAULT_CURRENCY;
    }, [siteConfig === null || siteConfig === void 0 ? void 0 : siteConfig.currency]);
    return {
        currency: currency,
        code: currency.code,
        symbol: currency.symbol,
        name: currency.name,
        locale: currency.locale,
    };
};
exports.useCurrency = useCurrency;
